import OpenAI from 'openai';
import { supabase } from "@/integrations/supabase/client";

export const initializeOpenAIClient = async (): Promise<OpenAI | null> => {
  try {
    console.log('Fetching OpenAI API key from Supabase...');
    
    const { data, error } = await supabase.functions.invoke('get-secret', {
      body: { key: 'OPENAI_API_KEY' }
    });
    
    if (error) {
      console.error('Error fetching API key:', error);
      throw error;
    }
    
    if (!data?.value) {
      console.error('No API key found in response');
      throw new Error('No API key found');
    }

    console.log('API key retrieved successfully');

    // Create OpenAI client
    const client = new OpenAI({
      apiKey: data.value,
      dangerouslyAllowBrowser: true
    });

    return client;
  } catch (error) {
    console.error('Error initializing OpenAI:', error);
    throw error;
  }
};